<app-header></app-header>

<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one" id="home">
    <ng-template carouselSlide *ngFor="let slide of slideStore">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-dark-05 main-hero-section" style="background-image: url('{{slide.image}}')">
            <div class="bg-dark-05">
                <div class="container">
                    <div class="position-middle">
                        <div class="row">
                            <div class="col-12">
                                <h1 class="display-5 fw-black uppercase">{{slide.title}}</h1>
                                <h2 class="display-4 fw-medium uppercase">{{slide.subtitle}}</h2>
                                <h1 class="display-5 fw-black uppercase">{{slide.subtitleTwo}}</h1>
                                <span class="call-us-wrap"><a class="button button-lg button-radius button-blue mt-3" routerLink="/about-us">Read more</a></span>
                                <div class="call-us" *ngFor="let call of slide.callUs">
                                  <h5>{{call.phone}}</h5>
                                  <h6>{{call.queryDesc}}</h6>
                                </div>
                            </div>
                        </div><!-- end row -->
                        
                    </div><!-- end row -->
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->

<!-- About section -->
<div class="section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 heading-style-one box-title">
        <h6 class="color-primary uppercase">About Agency</h6>
        <h2><span class="fw-black">We are an independent<br> strategic advertising <br> agency.</span></h2>
        <div class="welcome-style-two mt-30">
          <div class="thin-border-purple thin-borders float-start"></div>
          <p class="float-end">If you want to have the most success when you are creating a homepage for your site, it is a good idea. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquam vestibulum neque, id pellentesque purus dictum eget.</p>
        </div>
        <div class="row g-4 mt-4">
          <div class="col-12 col-lg-6 col-xl-6 dn-service-box text-center mb-5" *ngFor="let feature of features">
              <div class="circle-box-xl bg-light-theme mb-3">
                  <i class="bi color-primary" [ngClass]="feature.icon"></i>
              </div>
              <h3>{{feature.title}}</h3>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-6 pd-0">
        <img src="assets/images/about/intro-img-right.png" alt="about-img">
      </div>
    </div><!-- end row -->
  </div>
</div>
<!-- end About section -->

<!-- Portfolio section -->
<div class="section-md pd-t-0">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="circle-box-big shapes-wrap" data-opacity="0.1"></div>
      </div>
    </div>
    <div class="row portfolio-grid g-2 g-lg-3 mrt-60">
      <!-- Portfolio box -->
      <div *ngFor="let work of works" class="col-12 col-md-4 portfolio-item">
              <div class="portfolio-box">
                  <div class="portfolio-img">
                      <img src="assets/images/portfolio/grid/{{work.img}}" alt="gallery-img">
                  </div>
                  <a routerLink="/portfolio-one"></a>
                  <div class="portfolio-title">
                      <div>
                          <h5 class="fw-normal">{{work.title}}</h5>
                          <span>{{work.category}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- end Portfolio section -->

<!-- Services section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="color-primary uppercase">Why Choose Us</h6>
        <h2 class="display-6 fw-black">We are digital specialists. It's all we do</h2>
      </div>
    </div>
    <div class="row align-items-center mrt-50">
      <div class="col-md-4 main-service-box text-center" *ngFor="let service of services">
        <i class="bi" [ngClass]="service.icon"></i>
        <h4>{{service.title}}</h4>
        <p>{{service.desc}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12"><div class="triangle-light-blue-big shapes" data-opacity="0.15"></div></div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- What We Do section -->
<div class="section pd-t-0 pd-b-0">
  <div class="container-fluid pd-0">
    <div class="row row-flex flex-center">
      <div class="col-md-6 col-sm-12">
        <div class="col-inner pd-t-70 pd-b-50 spacer border-top border-bottom">
          <div class="heading-style-one">
            <h6 class="green-color uppercase">What We Do</h6>
            <h2 class="display-6 fw-black">How we build awesome<br>products</h2>
          </div>
          <div class="mrt-30">
          <p>We are an Creative agency, based in New York. Vision Every company is
            performing best online. Mission Helping businesses to find the perfect
            and most succesful strategy, to be online.</p>
            <a class="lightbox-media-box button-circle button-circle-md button-circle-outline-dark button-circle-hover-slide mrt-30" (click)="openPopup()">
              <i class="bi bi-play-fill"></i>
              <i class="bi bi-play-fill"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 bg-flex-cover" style="background-image: url(assets/images/about/about-img.jpg);"></div>
    </div>
  </div>
</div>
<!-- end What We Do section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Testimonial section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Testimonials</h6>
        <h2 class="display-6 fw-black">Our Clients Saying About Us</h2>
      </div>
    </div>
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial-two pd-0">
      <ng-template carouselSlide *ngFor="let tes of testimonials">
          <!-- Testimonial box -->
          <div class="testimonial-item">
              <div class="testimonial-content">
                  <div class="testimonial-content-in">
                      <div class="img">
                          <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                      </div>
                      <h5>{{tes.name}}</h5>
                      <h6>{{tes.position}}</h6>
                      <p>{{tes.desc}}</p>
                  </div>
              </div>
          </div>
      </ng-template>
  </owl-carousel-o>
    <div class="row">
      <div class="col-md-12">
        <div class="triangle-yellow-big d-sm-block" data-opacity="0.1"></div>
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Blogs section -->
<div class="section-lg pd-b-0">
  <div class="row">
    <div class="col-md-12">
      <div class="square-light-green-big shapes d-sm-block" data-opacity="0.1"></div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Our Blogs</h6>
        <h2 class="display-6 fw-black">Check What Happening Inside Score</h2>
      </div>
    </div>
    <div class="row align-items-center mrt-50">
        <div class="col-md-4" *ngFor="let post of posts">
            <div class="post">
                <div class="post-img">
                    <img class="img-responsive" [src]="post.image" [alt]="post.title">
                </div>
                <div class="post-info">
                    <h3>
                        <a routerLink="/blog-grid">{{ post.title }}</a>
                    </h3>
                    <h6 [ngClass]="post.color">
                        {{ post.category }}
                    </h6>
                    <p>{{ post.time }}</p>
                    <a class="readmore" routerLink="/blog-grid">
                        <span>
                            Read More
                            <i class="eicon bi bi-arrow-right-short"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Blogs section -->